import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import styled from "styled-components";
import Cookies from "js-cookie";
import storage from "../../../Storage";
import socket from "../../../Socket";
import {
  Event,
  wait,
  decode,
  encode,
  sendNotfication,
  RECAPTCHA,
} from "../../../Helper";
import C from "../../../Constant";
import { handleGoogleLogin, GoogleLoginButton } from "./GoogleLoginButton";
import Google from "./Google";
import { Eye, EyeOff } from "lucide-react";
import ForgetPassword from "./ForgetPassword";
import { Link } from "react-router-dom";

const StyledModal = styled(Modal)`
  .modal-dialog {
    max-width: 900px;
    margin: 20px auto;

    @media (max-width: 768px) {
      max-width: 100%;
      margin: 0;
      height: 100vh;
      display: flex;
      align-items: stretch;
    }

    @media (max-width: 480px) {
      max-width: 100%;
      margin: 0;
      height: 100vh;
    }
  }

  .modal-content {
    background-color: #232626;
    color: white;
    border-radius: 12px;
    border: none;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);

    @media (max-width: 768px) {
      border-radius: 0;
      height: 100vh;
      padding: 40px;
      max-height: 100vh;
    }

    @media (max-width: 700px) {
      border-radius: 0;
      height: 100vh;
      padding: 0px;
      max-height: 100vh;
    }
  }
`;

const LoginContainer = styled.div`
  display: flex;
  min-height: 500px;

  @media (max-width: 768px) {
    flex-direction: column;
    min-height: 100vh;
    height: 100vh;
  }
`;

const LoginLeft = styled.div`
  flex: 1;
  // background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // padding: 40px 20px;
  position: relative;

  @media (max-width: 768px) {
    // padding: 30px 20px;
    // min-height: 35vh;
    flex: 0 0 auto;
  }

  @media (max-width: 480px) {
    // padding: 20px 15px;
    min-height: 30vh;
  }
`;

const LoginTopImage = styled.img`
  max-width: 100%;
  height: auto;
  // margin-bottom: 20px;

  @media (max-width: 768px) {
    width: 100%;
    object-fit: cover;
    max-height: 300px;

    // margin-bottom: 15px;
  }

  @media (max-width: 480px) {
    width: 100%;
    // margin-bottom: 10px;
    object-fit: cover;
    max-height: 300px;
  }
`;

const LoginLogoImage = styled.img`
  max-width: 150px;
  height: auto;

  @media (max-width: 768px) {
    max-width: 120px;
  }

  @media (max-width: 480px) {
    max-width: 100px;
  }
`;

const MobileCloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  color: white;
  font-size: 18px;
  cursor: pointer;
  display: none;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);

  @media (max-width: 768px) {
    display: flex;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
`;

const LoginRight = styled.div`
  flex: 1;
  padding: 40px;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    padding: 30px 25px;
    flex: 1;
    min-height: 65vh;
    overflow-y: auto;
  }

  @media (max-width: 480px) {
    padding: 25px 20px;
    min-height: 70vh;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    margin-bottom: 25px;
  }

  @media (max-width: 480px) {
    margin-bottom: 20px;
  }
`;

const SignInTitle = styled.h2`
  font-size: 28px;
  font-weight: 600;
  margin: 0;
  color: white;

  @media (max-width: 768px) {
    font-size: 24px;
  }

  @media (max-width: 480px) {
    font-size: 22px;
  }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: #9ca3af;
  font-size: 24px;
  cursor: pointer;
  padding: 5px;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;

  // @media (max-width: 768px) {
  //   display: none;
  // }

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: white;
  }
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const InputLabel = styled.label`
  color: #9ca3af;
  font-size: 14px;
  font-weight: 500;
`;

const InputContainer = styled.div`
  position: relative;
  width: 100%;
`;

const StyledInput = styled.input`
  width: 100%;
  background-color: #1e2121;
  border: 2px solid #3a4142;
  border-radius: 8px;
  color: white;
  padding: 12px 16px;
  font-size: 16px;
  transition: all 0.3s ease;

  ${(props) =>
    props.hasIcon &&
    `
    padding-right: 45px;
  `}

  &::placeholder {
    color: #6b7280;
    font-weight: 400;
  }

  &:focus {
    outline: none;
    border-color: #ffa500;
    box-shadow: 0 0 0 3px rgba(255, 165, 0, 0.1);
    background-color: #252828;
  }

  @media (max-width: 480px) {
    padding: 10px 14px;
    font-size: 16px; /* Prevent zoom on iOS */
  }
`;

const EyeIcon = styled.button`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: #6b7280;
  padding: 5px;
  border-radius: 4px;

  &:hover {
    color: #9ca3af;
    background: rgba(255, 255, 255, 0.05);
  }
`;

const ForgotPasswordLink = styled(Link)`
  color: #ffa500;
  text-decoration: none;
  font-size: 14px;
  align-self: flex-end;
  margin-top: -10px;

  &:hover {
    color: #ffb347;
    text-decoration: underline;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 10px;
`;

const SignInButton = styled.button`
  width: 100%;
  background: linear-gradient(90deg, #ffd700, #ff8c00);
  box-shadow: 0 4px 15px rgba(255, 140, 0, 0.3);
  border: none;
  border-radius: 8px;
  color: #000;
  padding: 14px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 140, 0, 0.4);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
  }

  @media (max-width: 480px) {
    padding: 12px;
    font-size: 15px;
  }
`;

const SignUpSection = styled.div`
  text-align: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #3a4142;
  color: #9ca3af;
  font-size: 14px;
`;

const SignUpButton = styled.button`
  background: none;
  border: none;
  color: #ffa500;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  margin-left: 5px;

  &:hover {
    color: #ffb347;
    text-decoration: underline;
  }
`;

const SocialLoginContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 20px;
`;

const StyledSignInButton = styled.button`
  font-size: 16px;
  color: white;
  background-color: transparent;
  border: 1px solid #6b7280;
  border-radius: 10px;
  padding: 7px 18px;
  white-space: nowrap;

  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;

  @media (max-width: 400px) {
    padding: 6px !important;
    height: 2.1rem !important;
    font-size: 12px !important;
  }

  &:hover {
    border-color: #ffa500;
    color: #ffa500;
    background-color: rgba(255, 165, 0, 0.05);
  }
`;

// 2FA Modal Styles
const TwoFAModal = styled(Modal)`
  .modal-dialog {
    max-width: 400px;
  }

  .modal-content {
    background-color: #1e2124;
    color: white;
    border-radius: 12px;
    border: none;
    overflow: hidden;
  }
`;

const TwoFAHeader = styled.div`
  padding: 25px 25px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TwoFATitle = styled.h4`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
`;

const TwoFABody = styled.div`
  padding: 25px;
`;

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLogged: storage.getKey("logged"),
      show: this.props.show ? this.props.show : false,
      username: "",
      password: "",
      status: false,
      submitted: false,
      disabled: false,
      effect: "zoomIn",
      show2faModal: false,
      verificationCode: "",
      showPassword: false,
    };
  }

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  componentDidMount() {
    socket.on(C.LOGIN_USER, (data) => this.setLogin(decode(data)));
    Event.on("login_form", () => {
      this.handleShow();
    });
    Event.on("forgetpass_form", () => {
      this.handleShow();
    });
  }

  setLogin = (data) => {
    if (data.status === "2fa") {
      Cookies.set("session", data.token, { expires: 14 });
      storage.setKey("token", data.token);
      socket.connect(data.token);
      this.setState({ show2faModal: true });
      return;
    }

    if (data.status === true) {
      sendNotfication(
        "Successfully Login, Please Wait...",
        "success",
        "bottom-left"
      );
      Cookies.set("session", data.token, { expires: 14 });
      storage.setKey("logged", true);
      storage.setKey("token", data.token);
      storage.setKey("name", data.name);
      storage.setKey("avatar", data.avatar);
      storage.setKey("email", data.email);
      storage.setKey("credit", data.credit);
      storage.setKey("room", data.room);
      storage.setKey("friends", data.friends);
      storage.setKey("coin", "INR");
      wait(500).then(() => {
        window.location.reload();
      });
    } else {
      this.setState({ submitted: false, disabled: false });
      sendNotfication(data.status, "error", "bottom-left");
    }
  };

  handleShow = () => {
    this.setState({ show: true, effect: "zoomIn" });
  };

  handleClose = () => {
    this.setState({
      show: false,
      effect: "zoomOut",
      disabled: false,
      status: false,
      submitted: false,
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    this.setState({ submitted: true, disabled: true, status: "Please wait" });

    const { username, password } = this.state;

    if (!(username && password)) {
      this.setState({ disabled: false, status: false });
      return;
    }

    wait(200).then(() => {
      socket.emit(
        C.LOGIN_USER,
        encode({
          username: username,
          password: password,
          recaptcha: "google",
        })
      );
    });
  };

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  signup = (e) => {
    e.preventDefault();
    this.handleClose();
    Event.emit("register_form");
  };

  forgetPass = (e) => {
    e.preventDefault();
    this.handleClose();
    Event.emit("forgetpass_form");
  };

  handle2FAClose = () => {
    this.setState({ show2faModal: false, verificationCode: "" });
  };

  handle2FASubmit = (e) => {
    e.preventDefault();
    const { verificationCode, password } = this.state;

    socket.emit(C.TWO_FA_CONFIRM, encode({ code: verificationCode, password }));

    socket.once(C.TWO_FA_CONFIRM, (result) => {
      const decodedResult = decode(result);
      console.log(decodedResult);

      if (decodedResult.status === true) {
        sendNotfication("Verification successful!", "success", "bottom-left");
        window.location.reload();
      } else {
        sendNotfication(
          decodedResult.message || "Verification failed",
          "error",
          "bottom-left"
        );
        this.setState({ verificationCode: "" });
      }
    });
  };

  render() {
    const { show, username, password, disabled, show2faModal, showPassword } =
      this.state;

    return (
      <>
        {storage.getKey("logged") ? null : (
          <StyledSignInButton
            onClick={this.handleShow}
            className="login-trigger-btn"
          >
            Sign in
          </StyledSignInButton>
        )}

        <StyledModal
          size="lg"
          centered={false}
          show={storage.getKey("logged") ? false : show}
          onHide={this.handleClose}
          aria-labelledby="login-modal"
          className={`login-modal animated ${this.state.effect}`}
        >
          <LoginContainer className="login-container">
            <LoginLeft className="login-left-panel">
              <LoginTopImage
                className="login-hero-image"
                src="/assets/bcimages/login/signup.png"
                alt="Login Visual"
              />
              {/* <LoginLogoImage
                className="login-brand-logo"
                src="/assets/bcimages/assamgames.png"
                alt="Brand Logo"
              /> */}
              <MobileCloseButton
                onClick={this.handleClose}
                className="mobile-close-btn"
              >
                ×
              </MobileCloseButton>
            </LoginLeft>

            <LoginRight className="login-right-panel">
              <ModalHeader className="login-header">
                <SignInTitle className="login-title">Sign in</SignInTitle>
                <CloseButton
                  onClick={this.handleClose}
                  className="desktop-close-btn"
                >
                  ×
                </CloseButton>
              </ModalHeader>

              <StyledForm onSubmit={this.handleSubmit} className="login-form">
                <InputGroup className="username-input-group">
                  <StyledInput
                    name="username"
                    value={username}
                    onChange={this.handleInputChange}
                    placeholder="Username / Phone Number"
                    className="username-input"
                    autoComplete="username"
                  />
                </InputGroup>

                <InputGroup className="password-input-group">
                  <InputContainer className="password-input-container">
                    <StyledInput
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={password}
                      onChange={this.handleInputChange}
                      placeholder="Password"
                      className="password-input"
                      hasIcon
                      autoComplete="current-password"
                    />
                    <EyeIcon
                      type="button"
                      onClick={this.togglePasswordVisibility}
                      className="password-toggle-btn"
                    >
                      {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                    </EyeIcon>
                  </InputContainer>
                </InputGroup>

                <ForgotPasswordLink
                  to="/resetPassword"
                  className="forgot-password-link"
                >
                  Forgot password?
                </ForgotPasswordLink>

                <ButtonContainer className="button-container">
                  <SignInButton
                    type="submit"
                    disabled={disabled}
                    className="signin-submit-btn"
                  >
                    {disabled ? "Signing in..." : "Sign In"}
                  </SignInButton>
                </ButtonContainer>

                <SignUpSection className="signup-section">
                  New to betbazaar365.com?
                  <SignUpButton
                    onClick={this.signup}
                    className="signup-trigger-btn"
                  >
                    Create Account
                  </SignUpButton>
                </SignUpSection>

                <SocialLoginContainer className="social-login-container">
                  {/* Google login button here */}
                </SocialLoginContainer>
              </StyledForm>
            </LoginRight>
          </LoginContainer>
        </StyledModal>

        <TwoFAModal
          size="sm"
          centered
          show={show2faModal}
          onHide={this.handle2FAClose}
          aria-labelledby="2fa-modal"
          className="two-fa-modal"
        >
          <TwoFAHeader className="two-fa-header">
            <TwoFATitle className="two-fa-title">Enter 2FA Code</TwoFATitle>
            <CloseButton
              onClick={this.handle2FAClose}
              className="two-fa-close-btn"
            >
              ×
            </CloseButton>
          </TwoFAHeader>
          <TwoFABody className="two-fa-body">
            <StyledForm onSubmit={this.handle2FASubmit} className="two-fa-form">
              <InputGroup className="verification-input-group">
                <StyledInput
                  type="text"
                  name="verificationCode"
                  value={this.state.verificationCode}
                  onChange={this.handleInputChange}
                  placeholder="Enter 6-digit code"
                  maxLength="6"
                  className="verification-code-input"
                  autoComplete="one-time-code"
                />
              </InputGroup>
              <ButtonContainer className="verification-button-container">
                <SignInButton type="submit" className="verify-submit-btn">
                  Verify
                </SignInButton>
              </ButtonContainer>
            </StyledForm>
          </TwoFABody>
        </TwoFAModal>
      </>
    );
  }
}

export default Login;
